export default __webpack_public_path__ + "static/media/Group 3216@2x.f8721abc.png";